// removed by extract-text-webpack-plugin
module.exports = {"container":"K1-lcYGvWrdopfTz_i2rU","title":"_1pOsDKWoIRxQ-Ij5TnhnI6","chart":"_2gbfjfsoJJG6IJgZ4NsL_P"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Main/Market/styles.css
// module id = 1626
// module chunks = 85